export const isInactive = <T extends string>(
  selected: T[],
  all: readonly T[],
): boolean =>
  all.length === 0 ||
  selected.length === 0 ||
  all.every((code) => selected.includes(code));
